import { AutopilotTaskDto } from '@urbanx/agx.activities.client'

export const sortTasksByCompletionThenOrder = (
  a: AutopilotTaskDto,
  b: AutopilotTaskDto
): number => {
  const aCompleted = Boolean(a.isCompleted)
  const bCompleted = Boolean(b.isCompleted)

  if (aCompleted !== bCompleted) return aCompleted ? 1 : -1

  return (a.order ?? 0) - (b.order ?? 0)
}
